import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { List, Collapse } from '@mui/material'
import { SvgIconComponent } from '@mui/icons-material'
import { SvgIconComponent as CustomSvgIconComponent } from 'shared/types'
import { ModuleRoute } from 'shared/types'
import { DrawerSubItemLink } from './SubrouteList.style'
import DrawerItem from './DrawerItem'
import { isBookingPath } from 'modules/booking/utils'

type ModuleSubroutes = Required<ModuleRoute>['subroutes']

export interface SubrouteListProps {
  data: ModuleSubroutes
  label?: string
  icon?: SvgIconComponent | CustomSvgIconComponent
  onClose?: () => void
}

const SubrouteList = ({ data, label, icon, onClose }: SubrouteListProps) => {
  const location = useLocation()

  const [expanded, setExpanded] = useState(isBookingPath(location.pathname))

  useEffect(() => {
    if (isBookingPath(location.pathname)) {
      setExpanded(true)
    }
  }, [location.pathname])

  return (
    <>
      <DrawerItem
        icon={icon}
        label={label}
        onClick={() => setExpanded(!expanded)}
        expanded={expanded}
      />
      <Collapse in={expanded}>
        <List disablePadding>
          {data.map(({ path, linkSettings = {} }, i) => (
            <DrawerSubItemLink
              key={`nav-item-${i}`}
              path={path}
              to={path}
              {...linkSettings}
              onClick={onClose}
            />
          ))}
        </List>
      </Collapse>
    </>
  )
}

export default SubrouteList
